<template>
    <div v-if="show" class="custom-modal-backdrop" @click="handleBackdropClick">
        <div class="custom-modal-outer" tabindex="-1">
            <div class="custom-modal-dialog">
                <div class="custom-modal-content text-center" @click.stop>
                    <div class="modal-body">
                        <img :src="imgSrc" style="height: 80px;" class="mb-2 fa-bounce" alt="img"
                            :class="modalTypeClass" @click.stop />
                        <h5 class="modal-title w-100 mt-2">{{ computedTitle }}</h5>
                        <slot>
                            <p v-if="type !== 'message' || computedMessage" style="color:#707070;font-size: 14px;">{{
                                computedMessage }}</p>
                        </slot>
                        <div v-if="type === 'confirmation'" class="mt-5">
                            <button type="button" class="btn shadow-none me-3" @click="onCancel">
                                Cancel
                            </button>
                            <button type="button" class="btn custom-btn-success me-2" @click="onConfirm">
                                Confirm
                            </button>
                        </div>
                        <div v-if="type === 'success'" class="mt-5">
                            <button type="button" class="btn custom-btn-success me-2" @click="onConfirm">
                                Ok
                            </button>
                        </div>
                        <div v-if="type === 'message'" class="mt-5">
                            <button type="button" class="btn custom-btn-success me-2" @click="onCancel">
                                Ok
                            </button>
                        </div>
                        <div v-else class="mt-5">
                            <button v-if="type === 'error'" type="button" :class="['btn', closeBtnClass]" @click="close"
                                :disabled="type === 'message' && !computedMessage">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GlobalModal",
    props: {
        show: { type: Boolean, required: true },
        title: { type: String, default: "" },
        message: { type: String, default: "" },
        type: {
            type: String,
            default: "message", // "success", "error", "message", "confirmation"
            validator: (v) =>
                ["success", "error", "message", "confirmation"].includes(v),
        },
    },
    emits: ["close", "confirm", "cancel"],
    data() {
        return {
            _timer: null,
        };
    },
    computed: {
        modalTypeClass() {
            return {
                "custom-modal-success": this.type === "success",
                "custom-modal-error": this.type === "error",
                "custom-modal-message": this.type === "message",
                "custom-modal-confirmation": this.type === "confirmation",
            };
        },
        closeBtnClass() {
            if (this.type === "error") return "btn-danger";
            if (this.type === "success") return "custom-btn-success";
            if (this.type === "message") return "btn-primary";
            return "btn-secondary";
        },
        computedTitle() {
            if (this.title) return this.title;
            switch (this.type) {
                case "success": return "Success";
                case "error": return "Error";
                case "confirmation": return "Please Confirm";
                case "message": return "Message";
                default: return "Notification";
            }
        },
        computedMessage() {
            if (this.message) return this.message;
            switch (this.type) {
                //case "success": return "Operation completed successfully.";
                //case "error": return "An error occurred. Please try again.";
                case "confirmation": return "Are you sure you want to proceed?";
                case "message": return ""; // Require message for 'message' type
                default: return "";
            }
        },
        imgSrc() {
            switch (this.type) {
                case 'success': return '/img/success.png';
                case 'error': return '/img/error.png';
                case 'message': return '/img/message.png';
                case 'confirmation': return '/img/confirmation.png';
                default: return '/img/message.png';
            }
        },
    },
    watch: {
        show(val) {
            if (val) this.setupAutoClose();
        },
        type() {
            this.setupAutoClose();
        },
    },
    methods: {
        close() {
            this.$emit("close");
            this.close();
        },
        onConfirm() {
            this.$emit("confirm");
            this.close();
        },
        onCancel() {
            this.$emit("cancel");
            this.close();
        },
        setupAutoClose() {
            clearTimeout(this._timer);
            if (this.type === "message") {
                this._timer = setTimeout(this.close, 5000);
            }
            // error and confirmation: manual close only
        },
        handleBackdropClick() {
            if (this.type === "success") {
                this.close();
            } else if (this.type === "confirmation") {
                this.onCancel();
            }
        },
    },
    beforeUnmount() {
        clearTimeout(this._timer);
    },
    mounted() {
        if (this.show) this.setupAutoClose();
    },
};
</script>

<style scoped>
.custom-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.custom-modal-outer {
    width: 100vw;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-modal-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.custom-modal-content {
    background: #fff !important;
    color: #212529;
    border-radius: 2em;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);


    margin: auto;
    pointer-events: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
}

.modal-header {
    flex: 0 0 auto;
}

.modal-body {
    padding: 2.5rem;
    margin-left: 5em;
    margin-right: 5em;
}

.modal-footer {
    flex: 0 0 auto;
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.modal-title {
    color: #333333;
}

.custom-btn-success {
    background: #409B39;
    color: white;
}

/* .custom-modal-success {
    border-top: 6px solid #409B39;
}

.custom-modal-error {
    border-top: 6px solid #e74c3c;
}

.custom-modal-message {
    border-top: 6px solid #3498db;
}

.custom-modal-confirmation {
    border-top: 6px solid #f39c12;
} */
</style>